<div class="recent-activity-wrapper">
  <h3>My Recent Activities</h3>
  <div class="list" *ngFor="let item of list;" class="activity-cards">
    <div class="motor-cards">
      <ul>
        <li>
          <span class="status"
            [ngStyle]="{background: item?.status?.backgroundColorCode, color: item?.status?.colorCode}">{{ item?.status?.title }}</span>
        </li>
        <li>
          <span class="date">{{ service?.getLastSeenFormat(item?.updatedDate) }}</span>
          <span></span>
        </li>
      </ul>
    </div>
    <div>{{ item?.title }}</div>
    <div>{{ item?.description }}</div>
  </div>
  <div class="actions">
    <button mat-button>Clear All</button>
    <button mat-button>View All</button>
  </div>
</div>
